import { BASE_URL_PROD } from '../../components/config/keys';
import React,{useEffect,useState,useRef} from "react";
import { useTranslation } from 'react-i18next';
import getTranslation from '../../utils/getTranslation';
import './styles.scss';
import { useDispatch, useSelector } from "react-redux"
import { Container, Row, Col, Form, Button,Modal,CloseButton } from "react-bootstrap"
import { useHistory } from "react-router";
import { getBest , getPage,addCommentairetherapeut} from "../../actions/mixedmode";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { apiClient } from "../../actions/api"

import { useParams } from "react-router";
import { SET_FORMULE, SET_FORMULE_UPDATE } from "../../constants/actions";
import moment from 'moment'

import ShowTimezone from '../../components/show_timezone/'
import Agenda       from '../../components/agenda/'
import { fetchAbonnement, agendaClickToParams } from "../../actions/api_interface"

const Page = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const history = useHistory()
    const {slug,id } = useParams()
    const queryParams = new URLSearchParams(window.location.search);
    const isupdatetherapeut = queryParams.get('p');
    const slideElement = useRef(null);

    const [avgnote,    setavgnote]    = useState(0);
    const [value,      setValue]      = useState(1);
    const [show,       setShow]       = useState(false);
    const [therapeut,  setTherapeut]  = useState({});


    const { user,formule,formuleupdate } = useSelector(state => state.user);



    useEffect(() => {

      getdatatherapeut()

      if (!isupdatetherapeut) {
        fetchAbonnement(user, (data) => {
          if (data.abonnement?.formule) {
            let params = {'tarif':data.abonnement?.tarif, 'formule':data.abonnement?.formule}
            dispatch({ type: SET_FORMULE_UPDATE, payload: params })
            history.push('?p=true');
          }
        })
      }

      setTimeout(function(){
        slideElement.current && slideElement.current.slickGoTo(0)
      }, 1000);

    },[])


  function getdatatherapeut(){

    apiClient().get(`/getparticien/`+id)
    .then((res) => {
      setTherapeut(res.data)

      let sum=0;
      for (var i = 0; i < res.data?.avg?.length; i++) {
        sum=sum+parseInt(res.data?.avg[i].note)
      }
      if(sum>0){
        setavgnote(sum/res.data?.avg.length)
      }
    })
  }



  const handleClose = () => setShow(false);

  const onSelect = (day, hourState) => {
    if (hourState.state === 1) {
      let params = agendaClickToParams(day, hourState, therapeut)

      if (isupdatetherapeut === 'true') {
        if (formuleupdate?.formule) {
            params = Object.assign(params, {'tarif':formuleupdate?.tarif, 'formule':formuleupdate?.formule})
            dispatch({ type: SET_FORMULE_UPDATE, payload: params })
            sessionStorage.setItem('feelbetter_formule_update', JSON.stringify({
                tarif: formuleupdate?.tarif,
                formule: formuleupdate?.formule,
                therapeut: params.therapeut,
                date: params.date,
                heure: params.heure,
            }))
            history.push('/paiement/?p='+isupdatetherapeut)
        }
        else{
          history.push('/');
        }
      }
      else{
        if (formule?.formule) {
          params = Object.assign(params, {'tarif':formule?.tarif, 'formule':formule?.formule})
          dispatch({ type: SET_FORMULE, payload: params })
          sessionStorage.setItem('feelbetter_formule', JSON.stringify({
              tarif: params.tarif,
              formule: params.formule,
              therapeut: params.therapeut,
              date: params.date,
              heure: params.heure,
          }))
          history.push('/infos-patient');
        }
        else {
          dispatch({ type: SET_FORMULE, payload: params })
          sessionStorage.setItem('feelbetter_formule', JSON.stringify({
              tarif: params.tarif,
              formule: params.formule,
              therapeut: params.therapeut,
              date: params.date,
              heure: params.heure,
          }))
          history.push('/tarifs/?therapeute='+therapeut?.user_id);
        }
      }
    }
  }

    const goTo = () => {
      history.push('/profil-therapeute/Jaean-Piere')
    }

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };



    return (
        <div className="home profiltherapeut" >
          <section>
          <div className="ps-breadcrumb"><div className="container"><div className="ps-container"><ul className="breadcrumb"><li><a href="#" onClick={()=>history.push(`/`)}>Accueil</a></li><li>praticien</li><li>{therapeut?.first_name} {therapeut?.last_name}</li></ul></div></div></div>
          </section>


          <section className="section2 thisprofil listtherapeutes " >
                <Container>

                    <div className='therapeutescontent'>

                      <Row className=''>
                        <Col md={9} >
                             <div className='flexitems row'>
                                 <div className='itemimg col-md-3' style={{backgroundImage:therapeut.picture ? `url(${BASE_URL_PROD + "gestion/public/uploads/"+therapeut?.picture})` : "url('/images/default-profile.png')"}}>

                                 </div>
                                  <div className='itemheader col-md-9' >
                                    <h3>{therapeut?.first_name} {therapeut?.last_name}</h3>




                                 <div className="ps-product--detail ">
                                  <div className="ps-product__meta">
                                    <div className="ps-product__rating" >
                                        <div className="br-wrapper br-theme-fontawesome-stars"><select className="ps-rating" data-read-only="true" style={{display: 'none'}}>
                                            <option value="1">1</option>
                                            <option value="1">2</option>
                                            <option value="1">3</option>
                                            <option value="1">4</option>
                                            <option value="2">5</option>
                                        </select>
                                    <div className="br-widget br-readonly">
                                    </div>
                                    </div>
                                    <span>{therapeut?.avg?.length}  avis</span>
                                    </div>






                                </div>
                                </div>




                                  <div className='listtags'>
                                   {
                                      therapeut?.methodes?.map((met,i) =>(
                                         <div className='item'>{getTranslation(met?.tarif?.titre, i18n.language)}</div>
                                      )
                                    )}



                                     </div>



                                 </div>
                             </div>


                        </Col>
                        <Col md={3} >

                           <div className='actionrdv'>

                               <div className="text-center" >

                                    {
                                    /*
                                        <a href='javascript:void(0)' onClick={()=>goTo()} className='btnlink marauto' >Prendre rendez-vous </a>
                                    */
                                    }



                                </div>

                           </div>

                        </Col>
                       </Row>


                       <Row>
                         <Col md='12'>
                               <Box sx={{ width: '100%' }}>
                                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs   value={value} onChange={handleChange} aria-label="basic tabs example">
                                       <Tab label="Description" {...a11yProps(0)} />
                                       <Tab    label="Agenda" {...a11yProps(1)} />
                                       <Tab label={"Commentaires ("+therapeut?.avg?.length+")"} {...a11yProps(2)} />
                                    </Tabs>
                                  </Box>
                             </Box>
                         </Col>
                       </Row>

                    </div>



                </Container>
          </section>

<TabPanel value={value} index={0} className='tabpnel'>

           <section className="section2 " >
                <Container>

                <div className='row '>
                  <div className='col-md-12 '>

                      <p dangerouslySetInnerHTML={{ __html:therapeut?.description }}></p>

                  </div>
                </div>
               </Container>
            </section>
</TabPanel>

<TabPanel value={value} index={2} className='tabpnel'>

           <section className="section2 " >
                <Container>

                <div className='row '>
                  <div className='col-md-12 '>



              <Row>
              {therapeut?.avg?.map((item) => (
                <Col md={12}  >
                  <div className="comment mt-4 text-justify float-left" style={{    width: '100%',    display: 'flex',alignItems: 'flex-start'}}>
                   <div className='review-comments-avatar'> <img src="data:image/jpeg;base64,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" alt="" className="rounded-circle" width="80" height="80"/></div>
                     <div className='reviews-comments-item-text'>


                      <h4>{item.guest_name}</h4>
                        <div style={{float: 'right'}} className="br-wrapper stars-comment br-theme-fontawesome-stars"><select className="ps-rating" data-read-only="false" style={{display: 'none'}}>
                                                        <option value="0">0</option>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                    </select>
                                    <div className="br-widget br-readonly">
                                    </div>
                          </div>
                    <span>{moment(new Date(item.created_at)).format("DD/MM/YYYY")}</span>
                    <p>{item.comment}</p>



                     </div>
                </div>
                </Col>
                 ))}
              </Row>





                  </div>
                </div>
               </Container>
            </section>
</TabPanel>

<TabPanel value={value} index={1} className='tabpnel'>

           <section className="section2 " >
                <Container className='section30039'>

                <div className='row '>
                  <div className='col-md-12 '>
                        <h3 className='text-center'>{t('appointment.book_with_therapist')} <span style={{textTransform:'uppercase'}}>{therapeut.first_name}</span></h3>
                        <br/>
                  </div>
                </div>

                <div className="row">
                  <ShowTimezone />
                </div>
                <div className='row '>
                  <div className='col-md-12 bgplaning'>
                    <Agenda onSelect={onSelect} formule={formule} />
                  </div>
                </div>



                </Container>
          </section>


</TabPanel>








      <Modal show={show} onHide={handleClose} className='modelhermixtarif'   size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
        <Modal.Header   >
          <CloseButton variant="dark" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>




        </Modal.Body>
        <Modal.Footer>


        </Modal.Footer>
      </Modal>
        </div>
    );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default Page;